import { NON_CONVERSATION_TRIGGERS, UNATTACHED_TRIGGERS, WORKFLOW_FIRST_PATH, type WorkflowTrigger } from "@sagot/constants";
import type { Problem } from "./problem-model";
import type { Definition } from "./types";

/**
 * The rules of the backend's `graph_p5.py` for the conversation-control steps: a reply timer and a snooze need a
 * conversation to hold the timer (the triggers that start before one exists cannot use them), a snooze also needs a
 * conversation at all, and Start over goes back to Path A so it cannot sit in Path A. (A language needs a conversation
 * too; that is the generic `needs_conversation` of `actionProblems`.)
 */
export function conversationProblems(definition: Definition, trigger: WorkflowTrigger): Problem[] {
  const unattached = UNATTACHED_TRIGGERS.has(trigger);
  const conversationless = NON_CONVERSATION_TRIGGERS.has(trigger);
  const problems: Problem[] = [];
  for (const [path, body] of Object.entries(definition.paths)) {
    body.steps.forEach((step, index) => {
      const ofStep = (code: string): Problem => ({ code, where: `step ${step.id}`, path, stepId: step.id, params: {}, source: "client" });
      if (step.type === "collect_reply" && step.no_reply_after !== undefined && unattached) problems.push(ofStep("no_reply_timer_here"));
      if (step.type === "snooze" && unattached) problems.push(ofStep("no_snooze_here"));
      else if (step.type === "snooze" && conversationless) problems.push(ofStep("needs_conversation"));
      if (step.type === "reply_buttons" && step.start_over === true && path === WORKFLOW_FIRST_PATH) {
        problems.push({ code: "start_over_in_a", where: `paths.${path}.steps.${String(index)}`, path, stepId: step.id, params: {}, source: "client" });
      }
    });
  }
  return problems;
}
